import moment from 'moment';

export default {
    /** @returns { Object } */
    now: () => new Date(),

    /** @returns { Object } */
    startOfToday: () => (
        moment()
            .startOf( 'day' )
            .toDate()
    ),

    /**
     * @returns { Object }
     * @params numOfDays { Number }
     */
    daysFromToday: ( numOfDays ) => (
        moment()
            .startOf( 'day' )
            .add( numOfDays, 'days' )
            .toDate()
    ),

    /**
     * @returns { Object }
     * @params numOfDays { Number }
     */
    daysBeforeToday: ( numOfDays ) => (
        moment()
            .startOf( 'day' )
            .subtract( numOfDays, 'days' )
            .toDate()
    ),

    /**
     * @returns { Object }
     * @params numOfDays { Number }
     */
    daysBefore: ( dateString, numOfDays ) => (
        moment( dateString )
            .startOf( 'day' )
            .subtract( numOfDays, 'days' )
            .toDate()
    ),

    /**
     * @public
     * Format a dateString to the 'YYYY-MM-DD' format
     * @param dateString { String || Number }
     * @returns { String }
     */
    formatDate( dateString ) {
        return moment( dateString ).isValid()
            ? moment( dateString ).format( 'YYYY-MM-DD' )
            : dateString;
    },

    /**
     * @public
     * @params { Number } timestamp
     * @returns { Object }
     */
    parseTimestamp( timestamp ) {
        return moment.unix( timestamp );
    },
};
